// Modules
import { allCountries } from "country-region-data"

export interface RegionShape {
  code: string
  name: string
}

export interface CountryDataShape {
  code: string
  name: string
}

export interface RegionData {
  [key: string]: RegionShape[]
}

export interface CountryRegion {
  regions: RegionData
  countries: CountryDataShape[]
}

// allCountries structure: [countryName, countryShortCode, [[regionName, regionShortCode], ...]]
type CountryTuple = [string, string, [string, string][]]

export const getCountryRegionData = (): CountryRegion => {
  const regions: RegionData = {}
  const countries: CountryDataShape[] = []

  ;(allCountries as CountryTuple[]).forEach(
    ([countryName, countryShortCode, countryRegions]) => {
      // Save Countries
      countries.push({
        code: countryShortCode,
        name: countryName,
      })

      // Save Regions
      if (countryRegions) {
        regions[countryShortCode] = countryRegions.map(
          ([name, shortCode]) => {
            return { code: shortCode || "", name }
          }
        )
      }
    }
  )

  return { regions, countries }
}

export const countryRegionData = getCountryRegionData()

export const getCountryByCode = (code: string): CountryDataShape | undefined => {
  let result

  if (code) {
    result = countryRegionData?.countries.find(({ code: cd }) => cd === code)
  }

  return result
}

export const getRegionByCountryAndCode = (
  country: string,
  code: string
): RegionShape => {
  let result

  if (country && code) {
    result = countryRegionData?.regions[country]?.find(
      ({ code: cd }) => cd === code
    )
  }

  return result
}
